import request from '@/utils/request'

const _Prefix = "/companySet"

// 查询系统信息列表
export function sysList(query) {
    return request({
        url: _Prefix + '/list',
        method: 'get',
        params: query
    })
}


// 查询系统信息详细
export function getSys(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'get'
    })
}

// 新增系统信息
export function addSys(data) {
    return request({
        url: _Prefix,
        method: 'post',
        data: data
    })
}

// 修改系统信息
export function updateSys(data) {
    return request({
        url: _Prefix,
        method: 'put',
        data: data
    })
}

// 删除系统信息
export function delSys(id) {
    return request({
        url: _Prefix + '/' + id,
        method: 'delete'
    })
}